import React from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../lib/supabase';

const LANG_KEY = 'borderjudge-lang';

const LanguageToggle: React.FC = () => {
  const { i18n } = useTranslation();

  const toggleLang = async () => {
    const next = i18n.language === 'zh' ? 'en' : 'zh';
    i18n.changeLanguage(next);
    localStorage.setItem(LANG_KEY, next);

    // 同步到数据库（跨设备）
    const { data: { session } } = await supabase.auth.getSession();
    if (session) {
      supabase.from('profiles').upsert(
        { user_id: session.user.id, language: next },
        { onConflict: 'user_id' }
      );
    }
  };

  return (
    <button className="lang-btn" onClick={toggleLang}>
      {i18n.language === 'zh' ? 'EN' : '中文'}
    </button>
  );
};

export default LanguageToggle;
